export default "__VITE_ASSET__CBjwpvUL__"